import * as Sentry from '@sentry/browser';
import config from 'favoris-web/config/environment';

export function initialize(): void {
  const dsn = config.favoris.sentryDsn as string | undefined;
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: config.environment || 'development',
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    integrations: [],
  });
}

export default { initialize };
